export default __webpack_public_path__ + "static/media/phoneMobile.74d72483.svg";